import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";
import { _get } from "../services/apiClient";
import { IoGlobeOutline } from "react-icons/io5";

export default function LanguageHandler() {
  const { i18n } = useTranslation();
  const [languages, setLanguages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const res = await _get("/languages/availableLanguages");

        setLanguages(res.data);

        const current = res.data.find((l) => l.code === i18n.language);
        document.documentElement.dir = current?.direction || "ltr";
      } catch (err) {
        console.error("Error fetching languages:", err);
      }
    };

    fetchLanguages();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleChange = (lang) => {
    i18n.changeLanguage(lang);

    const selectedLang = languages.find((l) => l.code === lang);
    document.documentElement.dir = selectedLang?.direction || "ltr";
    setIsOpen(false);
  };

  if (!languages || languages.length < 2) {
    return null;
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center gap-1 px-2 py-2 rounded-lg hover:bg-orange-50 transition-colors duration-300 border border-orange-200/50"
      >
        <IoGlobeOutline className="text-xl text-orange-600" />
        <svg
          className={`w-3 h-3 text-gray-600 transition-transform duration-200 ${isOpen ? "rotate-180" : ""
            }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full end-0 mt-2 bg-white rounded-lg shadow-xl border border-orange-200/50 py-2 min-w-[160px] z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleChange(lang.code)}
              className={`w-full text-start px-4 py-2 text-sm hover:bg-orange-50 transition-colors ${lang.code === i18n.language
                ? "bg-orange-100 text-orange-600 font-semibold"
                : "text-gray-700"
                }`}
            >
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
